import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';

const STitleLabel = styled.h5`
  position: relative;
  display: block;
  background: ${color.light};
  border-radius: 2px;
  padding: 15px 20px;
  border: unset;
  margin-bottom: unset;
  font-family: var(--bold-font);
  font-weight: 700;
  color: ${color.dimgray};
  font-size: 16px;
  cursor: pointer;
  border-radius: 3px;

  @media ${device.tablet} {
    margin-bottom: 16px;
    border: 1px solid ${color.gainsboro};
  }
`;

const STitleOptions = styled.div`
  background: ${color.light};
  border-radius: 2px;
  border: unset;
  display: block;
  margin-bottom: unset;
  padding: 15px 20px;
  position: relative;

  @media ${device.tablet} {
    border: 1px solid ${color.gainsboro};
    margin-bottom: 15px;
  }
`;

const STitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  cursor: pointer;
  font-family: var(--bold-font);
  font-weight: 700;
  color: ${color.dimgray};

  &:nth-child(2) {
    font-family: var(--regular-font);
    font-weight: normal;
    color: ${color.midgray};
    font-size: 14px;
  }
`;

const SPopoverContent = styled.div`
  position: relative;
  display: block;
  border: 1px solid ${color.gainsboro};
  border-radius: 3px;

  > * {
    display: flex;
    justify-content: flex-start;
  }

  > * :hover {
    background: ${color.aliceBlue};
    color: ${color.primary};
    width: 100%;
  }
`;

const ListContainer = styled(Flex).attrs({ align: 'center' })`
  padding-left: 8px;
  cursor: pointer;

  :hover {
    background: ${color.aliceBlue};
  }
`;

export {
  STitleLabel,
  STitleOptions,
  STitleWrapper,
  SPopoverContent,
  ListContainer,
};
